<template>
  <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.00002 21.3333C2.00002 22.8 3.20002 24 4.66669 24H15.3334C16.8 24 18 22.8 18 21.3333V5.33333H2.00002V21.3333ZM19.3334 1.33333H14.6667L13.3334 0H6.66669L5.33335 1.33333H0.666687V4H19.3334V1.33333Z" fill="#00263E"/>
  </svg>
</template>

<script>
export default {};
</script>
